import { render } from "./ScoreScale.vue?vue&type=template&id=4a6359c5&scoped=true"
import script from "./ScoreScale.vue?vue&type=script&lang=js"
export * from "./ScoreScale.vue?vue&type=script&lang=js"

import "./ScoreScale.vue?vue&type=style&index=0&id=4a6359c5&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6359c5"]])

export default __exports__